// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.registration-modal-container h3 {
  margin-bottom: 1rem;
}
.registration-modal-container p {
  padding: 1rem;
}
.registration-modal-container .buttons {
  padding-top: 3rem;
}`, "",{"version":3,"sources":["webpack://./src/kit/scenes/RightsholderRegistrationLayout/RegistrationPopup/index.scss"],"names":[],"mappings":"AACE;EACE,mBAAA;AAAJ;AAGE;EACE,aAAA;AADJ;AAIE;EACE,iBAAA;AAFJ","sourcesContent":[".registration-modal-container {\n  h3 {\n    margin-bottom: 1rem;\n  }\n\n  p {\n    padding: 1rem;\n  }\n\n  .buttons {\n    padding-top: 3rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
